import { apiClient } from '../../app/api/client';

import type { ArchiveFilter } from '../catalog/types';
import type { FleetApi } from './types';

function listPath(search: string, archived: ArchiveFilter) {
  const query = new URLSearchParams({ archived, limit: '100', search });
  return `/fleet/units?${query.toString()}`;
}

export const fleetApi: FleetApi = {
  archiveUnit: (id) => apiClient.post(`/fleet/units/${id}/archive`),
  counts: () => apiClient.get('/fleet/availability'),
  createUnit: (payload) => apiClient.post('/fleet/units', { json: payload }),
  getUnit: (id) => apiClient.get(`/fleet/units/${id}`),
  importUnits: (csvText, allowPartial) =>
    apiClient.post('/fleet/units/import', {
      json: { allow_partial: allowPartial, csv_text: csvText },
    }),
  listUnits: (search, archived = 'exclude') =>
    apiClient.get(listPath(search, archived)),
  restoreUnit: (id) => apiClient.post(`/fleet/units/${id}/restore`),
  updateUnit: (id, payload) =>
    apiClient.put(`/fleet/units/${id}`, { json: payload }),
};
